module.exports = __webpack_public_path__ + "static/img/05.5d7ace7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/inno/05.jpg
// module id = 400
// module chunks = 1